module.exports = __webpack_public_path__ + "static/project-1-870c2ffdacb86fa3a39d0fcb3c0189e9.png";